// extracted by mini-css-extract-plugin
module.exports = {"backlink":"back-link_backlink__1pu11","backlinkContent":"back-link_backlinkContent__33A4l","icon":"back-link_icon__32xWB","text":"back-link_text__1xeKp"};